import { useState } from "react";
import { api } from "@/lib/api";
import { NEWSLETTER } from "@/constants/testIds";
import { motion } from "framer-motion";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle"); // idle | ok | err
  const [msg, setMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await api.post("/newsletter", { email });
      setState("ok");
      setMsg("Enrolled. Watch your inbox.");
      setEmail("");
    } catch {
      setState("err");
      setMsg("Something failed. Try again.");
    }
  };

  const year = new Date().getFullYear();

  return (
    <footer className="border-t vv-line mt-32 bg-[color:var(--vv-bg)]">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <img
              src="https://customer-assets-eiarnc6j.emergentagent.net/job_story-stage-18/artifacts/ygm2ivyo_ac177a3c-e752-4d60-986d-4a6b6608ec1e.png"
              alt="A. Lee Creations"
              className="w-24 h-24 mb-8 object-cover"
            />
            <div className="text-[10px] tracking-[0.3em] uppercase text-[color:var(--vv-bone-dim)] mb-6">
              — Correspondence
            </div>
            <h3 className="font-serif-vv text-4xl md:text-6xl leading-[0.95] tracking-tight">
              Where words
              <br />
              <span className="italic text-[color:var(--vv-bone-dim)]">
                forge worlds.
              </span>
            </h3>
            <p className="mt-6 max-w-md text-[color:var(--vv-bone-dim)]">
              No marketing. No cadence. Just early word on new titles, essays
              from our editors, and the occasional confession.
            </p>

            <form onSubmit={submit} className="mt-10 max-w-lg">
              <div className="flex border-b vv-line pb-2 gap-4">
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@address"
                  data-testid={NEWSLETTER.input}
                  className="flex-1 bg-transparent border-0 outline-none text-lg placeholder:text-[color:var(--vv-bone-dim)]/60"
                />
                <motion.button
                  whileHover={{ x: 4 }}
                  type="submit"
                  data-testid={NEWSLETTER.submit}
                  className="text-xs uppercase tracking-[0.3em] text-[color:var(--vv-ember)]"
                >
                  Enroll →
                </motion.button>
              </div>
              {state !== "idle" && (
                <p
                  data-testid={NEWSLETTER.success}
                  className={`mt-3 text-xs uppercase tracking-widest ${
                    state === "ok"
                      ? "text-[color:var(--vv-ember)]"
                      : "text-red-400"
                  }`}
                >
                  {msg}
                </p>
              )}
            </form>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] tracking-[0.3em] uppercase text-[color:var(--vv-bone-dim)] mb-6">
              — Imprint
            </div>
            <ul className="space-y-3 font-serif-vv text-2xl">
              <li>
                <a href="/catalog" className="vv-link">
                  Catalog
                </a>
              </li>
              <li>
                <a href="/authors" className="vv-link">
                  Authors
                </a>
              </li>
              <li>
                <a href="/journal" className="vv-link">
                  Journal
                </a>
              </li>
              <li>
                <a href="/about" className="vv-link">
                  Manifesto
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] tracking-[0.3em] uppercase text-[color:var(--vv-bone-dim)] mb-6">
              — Office
            </div>
            <address className="not-italic text-[color:var(--vv-bone-dim)] leading-relaxed">
              Independent Fiction
              <br />
              Correspondence &amp; Trade
              <br />
              <span className="text-[color:var(--vv-bone)]">
                alee1@aleecreations.org
              </span>
            </address>
          </div>
        </div>

        <div className="mt-24 pt-6 border-t vv-line flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="font-serif-vv text-xl italic">
            A. Lee Creations — where words forge worlds.
          </div>
          <div className="text-[10px] tracking-[0.3em] uppercase text-[color:var(--vv-bone-dim)]">
            © {year} A. Lee Creations · All rights reserved
          </div>
        </div>
      </div>
    </footer>
  );
}
